import { useIsMobile } from "@/hooks/use-mobile";

const paths = [
  "M -80 320 C 160 260, 340 180, 540 240 S 920 430, 1240 390 S 1580 250, 1720 300",
  "M -100 420 C 120 360, 300 280, 520 330 S 900 520, 1220 500 S 1540 340, 1720 380",
  "M -90 520 C 200 470, 380 360, 620 410 S 980 620, 1280 590 S 1560 440, 1740 470",
  "M -120 610 C 100 580, 320 500, 560 530 S 960 720, 1300 700 S 1580 560, 1750 590",
  "M -70 260 C 140 300, 360 420, 620 390 S 980 200, 1260 230 S 1530 360, 1730 340",
  "M -110 710 C 180 650, 360 600, 620 620 S 980 760, 1320 740 S 1560 680, 1740 700",
];

const AnimatedBackground = () => {
  const isMobile = useIsMobile();

  return (
    <div className="fixed inset-0 z-0 pointer-events-none overflow-hidden bg-[hsl(215_72%_17%)]">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_20%,hsl(200_100%_55%/0.10),transparent_35%),radial-gradient(circle_at_80%_40%,hsl(220_100%_60%/0.14),transparent_42%),linear-gradient(145deg,hsl(215_70%_14%),hsl(215_80%_18%),hsl(210_65%_22%))]" />

      {!isMobile && (
        <svg
          className="absolute inset-0 h-full w-full opacity-95"
          viewBox="0 0 1600 900"
          preserveAspectRatio="xMidYMid slice"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <linearGradient id="flow-stroke" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="hsl(200 100% 65% / 0.25)" />
              <stop offset="50%" stopColor="hsl(210 100% 72% / 0.7)" />
              <stop offset="100%" stopColor="hsl(200 100% 65% / 0.2)" />
            </linearGradient>
          </defs>

          {paths.map((d, index) => (
            <g key={d}>
              <path
                d={d}
                fill="none"
                stroke="url(#flow-stroke)"
                strokeWidth={index % 3 === 0 ? 2.4 : 1.6}
                strokeLinecap="round"
                opacity={0.35}
              />
            </g>
          ))}
        </svg>
      )}

      <div className="absolute inset-0 bg-[linear-gradient(to_bottom,hsl(215_70%_14%/0.10),transparent_18%,transparent_82%,hsl(215_70%_14%/0.18))]" />
    </div>
  );
};

export default AnimatedBackground;
